export default {
  props: {
    translation: Object
  },
  computed: {
    selectedLanguage () {
      return this.$store.getters['checklist/language'] || null
    },
    translatedLabel () {
      if (this.selectedLanguage && this.translation[this.selectedLanguage] && this.translation[this.selectedLanguage].label) {
        return this.translation[this.selectedLanguage].label
      }
      return this.label
    },
    translatedDescription () {
      if (this.selectedLanguage && this.translation[this.selectedLanguage] && this.translation[this.selectedLanguage].description) {
        return this.translation[this.selectedLanguage].description
      }
      return this.description
    }
  }
}
